# Toggles the classes on the fake radios. CSS implementation doesn't allows to use the builtin css selectors, so it
# has to be done through JS. It adds a click listener, but also initialise the correct CSS class on page change.

$(document).on 'change', '[type="radio"]', ->
  $this = $ this
  $("label.checked:has([type='radio'][name='#{this.name}'])").removeClass 'checked'
  $this.parent().addClass 'checked'

init = ->
  $("label:has([type='radio']:checked)").addClass 'checked'
  $("label:has([type='radio']:disabled)").addClass 'disabled'

$(document).ready init
